import { createReducer, AnyAction } from '@reduxjs/toolkit';

import { improvements as improvementsState } from '../state/improvements';
import {
  addImprovement,
  removeImprovement,
  getImprovementsForProcessInstance,
  fetchImprovementOptions,
  improvementSearch,
  updateImprovement
} from '../../../actions/improvements.actions';
import * as commonEnums from '../../../enums/index';
import { providerSearch } from '../actions/invoice-editor.actions';
// userDetailsAvailable and codeSearch import from barrel (circular) - use string literals.
import { providerSearchCache, searchCache } from '../typeahead-cache/caches';
import { resetCommonState } from '../../../actions/ui.actions';

const { ImprovementDictionaryProps } = commonEnums;

const improvementsFulfilled = (
  state: Accelerate.ImprovementsState,
  action: AnyAction
) => ({
  ...state,
  improvements: action.payload,
  searchResults: []
});

const improvements = createReducer(improvementsState, builder => {
  builder.addCase(resetCommonState.type, () => ({ ...improvementsState }));

  builder.addCase('USER_DETAILS', (state, action: AnyAction) => {
    const userDetails: CMxAPI.ContextAPI = action.payload;
    const userContext = userDetails.contexts.find(
      context => context.organizationId === userDetails.activeContextId
    );
    return {
      ...state,
      userContext
    };
  });

  builder.addCase('CODE_SEARCH/fulfilled', (state, action: AnyAction) => {
    const newResults = searchCache.getLatest(action.payload).searchResults;
    return { ...state, procedureSearchResults: newResults };
  });

  builder.addCase(getImprovementsForProcessInstance.fulfilled, improvementsFulfilled);
  builder.addCase(addImprovement.fulfilled, improvementsFulfilled);
  builder.addCase(removeImprovement.fulfilled, improvementsFulfilled);
  builder.addCase(updateImprovement.fulfilled, improvementsFulfilled);

  builder.addCase(fetchImprovementOptions.fulfilled, (state, action) => ({
    ...state,
    dictionaryValues: action.payload
  }));

  builder.addCase(improvementSearch, (state, action) => {
    const rowValues = state.dictionaryValues.rowValues;
    let searchResults = [];
    if (rowValues !== undefined) {
      searchResults = rowValues?.filter(o =>
        Object.keys(o).some(
          k =>
            (k === ImprovementDictionaryProps.ERROR_CODE ||
              k === ImprovementDictionaryProps.DESCRIPTION) &&
            o[k].toLowerCase().includes(action.payload.text.toLowerCase())
        )
      );
    }
    return {
      ...state,
      searchResults
    };
  });

  builder.addCase(providerSearch.fulfilled, (state, action) => {
    const fromCache = providerSearchCache.getLatest(action.payload);
    const providerSearchResults = fromCache.providers;
    return {
      ...state,
      providerSearchResults
    };
  });

  builder.addCase(providerSearch.rejected, state => ({
    ...state,
    providerSearchResults: []
  }));
});

export { improvements };
